const OS_LABELS = {
  iOS: "iOS",
  iPadOS: "iPadOS",
  macOS: "macOS",
  tvOS: "tvOS",
  visionOS: "visionOS",
  watchOS: "watchOS",
};

/** Hinweise erst ab dieser Hauptversion; ältere Geräte gibt es im MDM nicht mehr. */
const HINT_BASELINE_MAJOR = 18;

function shortVersion(version) {
  const text = String(version || "").trim();
  return text.replace(/\.0$/, "");
}

function majorVersion(version) {
  const match = String(version || "").trim().match(/^(\d+)/);
  return match ? Number(match[1]) : 0;
}

function meetsHintBaseline(os, version) {
  if (os === "watchOS") return false;
  if (os === "visionOS") return majorVersion(version) >= 1;
  return majorVersion(version) >= HINT_BASELINE_MAJOR;
}

function entriesFromIntroduced(introduced) {
  if (!introduced) return [];
  if (Array.isArray(introduced)) {
    return introduced
      .map((item) => ({ os: item.os || item.platform, version: item.version }))
      .filter((item) => item.os && item.version && item.version !== "n/a");
  }
  return Object.entries(introduced)
    .filter(([, version]) => version && version !== "n/a")
    .map(([os, version]) => ({ os, version }));
}

export default function OsVersionBadges({ introduced, supervised }) {
  const items = entriesFromIntroduced(introduced).filter((item) => meetsHintBaseline(item.os, item.version));
  if (!items.length && !supervised) return null;
  return (
    <span className="d-inline-flex flex-wrap gap-1 align-items-center">
      {items.map((item) => (
        <span
          key={`${item.os}-${item.version}`}
          className="profile-os-badge"
          title={`Verfügbar seit ${OS_LABELS[item.os] || item.os} ${item.version}`}
        >
          {OS_LABELS[item.os] || item.os} {shortVersion(item.version)}
        </span>
      ))}
      {supervised === true ? (
        <span className="profile-os-badge is-supervised" title="Nur auf betreuten (supervised) Geräten">
          sup
        </span>
      ) : null}
    </span>
  );
}
